module.exports = __webpack_public_path__ + "static/media/logo.6b044361.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/logo.svg
// module id = 1087
// module chunks = 0